import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link as RouterLink } from "react-router-dom";
import { tokens } from "../theme";
import SectionLabel from "../components/SectionLabel";

export default function NotFound() {
  return (
    <Box sx={{ bgcolor: tokens.bone, minHeight: "70vh", display: "flex", alignItems: "center" }}>
      <Container maxWidth="sm" sx={{ textAlign: "center" }}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <SectionLabel align="center">Page not found</SectionLabel>
        </Box>
        <Typography variant="h1" sx={{ fontSize: { xs: "4rem", md: "5.5rem" }, mt: 2 }}>
          404
        </Typography>
        <Typography sx={{ mt: 1.5, mb: 4 }}>
          That page wandered off. Head back to the gallery.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained" color="primary">
          Return home
        </Button>
      </Container>
    </Box>
  );
}
